import { FC } from 'react'

import { R } from 'core/helpers'
import { isNotFoundError } from 'core/helpers/error'
import { useEmployeeGetById } from 'core/types'

import ModelLink from './ModelLink'

type EmployeeLinkProps = {
  employeeId: string
}

const EmployeeLink: FC<EmployeeLinkProps> = ({ employeeId }) => {
  const { data: employee, isLoading } = useEmployeeGetById({
    employeeId,
    options: {
      throwOnError: R.isNot(isNotFoundError),
    },
  })

  return <ModelLink id={employeeId} isLoading={isLoading} model={employee} />
}

export default EmployeeLink
